import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { HayfeverChangePasswordSentComponent } from './hayfever-change-password-sent/hayfever-change-password-sent.component';
import { HayfeverForgotPasswordComponent } from './hayfever-forgot-password/hayfever-forgot-password.component';
import { HayfeverInputComponent } from './hayfever-input/hayfever-input.component';
import { HayfeverLoginComponent } from './hayfever-login/hayfever-login.component';
import { HayfeverOemHeaderComponent } from './hayfever-oem-header/hayfever-oem-header.component';
import { HayfeverOemLoginMessageComponent } from './hayfever-oem-login-message/hayfever-oem-login-message.component';
import { HayfeverOemRegisterMessageComponent } from './hayfever-oem-register-message/hayfever-oem-register-message.component';
import { HayfeverPasswordInputComponent } from './hayfever-password-input/hayfever-password-input.component';
import { HayfeverRegisterResendComponent } from './hayfever-register-resend/hayfever-register-resend.component';
import { HayfeverRegisterSendComponent } from './hayfever-register-send/hayfever-register-send.component';
import { HayfeverRegisterComponent } from './hayfever-register/hayfever-register.component';
import { HayfeverResetPasswordComponent } from './hayfever-reset-password/hayfever-reset-password.component';
import { HayfeverUnblockComponent } from './hayfever-unblock/hayfever-unblock.component';
import { HayfeverComponent } from './hayfever/hayfever.component';
import { OemService } from './oem.service';

@NgModule({
  declarations: [
    HayfeverComponent,
    HayfeverLoginComponent,
    HayfeverRegisterComponent,
    HayfeverUnblockComponent,
    HayfeverRegisterResendComponent,
    HayfeverRegisterSendComponent,
    HayfeverForgotPasswordComponent,
    HayfeverResetPasswordComponent,
    HayfeverChangePasswordSentComponent,
    HayfeverInputComponent,
    HayfeverPasswordInputComponent,
    HayfeverOemHeaderComponent,
    HayfeverOemRegisterMessageComponent,
    HayfeverOemLoginMessageComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    HayfeverResetPasswordComponent,
    HayfeverComponent,
    HayfeverRegisterResendComponent,
    HayfeverRegisterSendComponent,
    HayfeverUnblockComponent,
    HayfeverChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HayfeverModule {}
